import React from 'react';
import { memoize } from 'react-data-table-component';
import { TranslateExt } from '../contexts/LanguageContext';

export const DataTableColumns = {
    accountHistory: [
        {
            name: TranslateExt('Order'),
            selector: 'ticket',
            sortable: true,
            cell: d => <b>#{d.ticket}</b>
        },
        {
            name: TranslateExt('Time'),
            selector: 'opeN_TIME',
            sortable: true,
            minWidth: '150px'
        },
        {
            name: TranslateExt('Close Time'),
            selector: 'closE_TIME',
            sortable: true,
            minWidth: '150px'
        },
        {
            name: TranslateExt('Type'),
            selector: 'cmd',
            sortable: true
        },
        {
            name: TranslateExt('Size'),
            selector: 'volume',
            sortable: true
        },
        {
            name: TranslateExt('Symbol'),
            selector: 'symbol',
            sortable: true
        },
        {
            name: TranslateExt('Price'),
            selector: 'opeN_PRICE',
            sortable: true,
            cell: d=> d.opeN_PRICE.format('c')
        },
        {
            name: TranslateExt('Close Price'),
            selector: 'closE_PRICE',
            sortable: true,
            cell: d=> d.closE_PRICE.format('c')
        },
        {
            name: TranslateExt('S / L'),
            selector: 'sl',
            sortable: true
        },
        {
            name: TranslateExt('T / P'),
            selector: 'tp',
            sortable: true
        },
        {
            name: TranslateExt('Swap'),
            selector: 'swaps',
            sortable: true
        },
        {
            name: TranslateExt('Profit'),
            selector: 'profit',
            sortable: true,
            cell: d => <span className={(d.profit < 0 ? "text-danger" : "text-success")}>{d.profit}</span>
        }
    ],
    openTrades: [
        {
            name: TranslateExt('Order'),
            selector: 'ticket',
            sortable: true,
            cell: d => <b>#{d.ticket}</b>
        },
        {
            name: TranslateExt('Time'),
            selector: 'opeN_TIME',
            sortable: true
        },
        {
            name: TranslateExt('Type'),
            selector: 'cmd',
            sortable: true
        },
        {
            name: TranslateExt('Size'),
            selector: 'volume',
            sortable: true
        },
        {
            name: TranslateExt('Symbol'),
            selector: 'symbol',
            sortable: true
        },
        {
            name: TranslateExt('Price'),
            selector: 'opeN_PRICE',
            sortable: true,
            cell: d=> d.opeN_PRICE.format('c')
        },
        {
            name: TranslateExt('S / L'),
            selector: 'sl',
            sortable: true
        },
        {
            name: TranslateExt('T / P'),
            selector: 'tp',
            sortable: true
        },
        {
            name: TranslateExt('Swap'),
            selector: 'swaps',
            sortable: true
        },
        {
            name: TranslateExt('Profit'),
            selector: 'profit',
            sortable: true,
            cell: d => <span className={(d.profit < 0 ? "text-danger" : "text-success")}>{d.profit}</span>
        }
    ],
    transferHistory: [
        {
            name: TranslateExt("Login"),
            selector: 'login',
            cell: d => <b>#{d.login}</b>,
            width: '100px'
        },
        {
            name: TranslateExt("PSP"),
            selector: 'psp',
            cell: d => <span><img src={"/assets/psp-logo/" + (d.pspLogo || "defaultlogo.svg")} alt="" width="30" className="mb-1" />&nbsp; {d.psp}</span>,
            minWidth: '150px'
        },
        {
            name: TranslateExt("Amount"),
            selector: 'amount',
            width: '100px'
        },
        {
            name: TranslateExt("Date"),
            selector: 'date'
        },
        {
            name: TranslateExt('Status'),
            selector: 'status',
            cell: d => (d.status === 1 ? <span className="badge badge-success pb-1">{TranslateExt("Deposit")}</span> : <span className="badge badge-warning pb-1">{TranslateExt("Withdrawal")}</span>),
            width: '100px'
        }
    ],
    deposit: [
        {
            name: TranslateExt('#'),
            selector: 'id',
            sortable: true,
            maxWidth:'50px',
            cell: d => <span className="badge badge-light">{d.id}</span>
        },
        {
            name: TranslateExt('Login'),
            selector: 'login',
            sortable: true,
            cell: d => <b>#{d.login}</b>
        },
        {
            name: TranslateExt('PSP'),
            selector: 'psp',
            sortable: true,
            cell: d => <span><img src={"/assets/psp-logo/" + (d.pspLogo || "defaultlogo.svg")} alt="" width="30" className="mb-1" />&nbsp; {d.psp}</span>
        },
        {
            name: TranslateExt('Amount'),
            selector: 'amount',
            sortable: true,
            cell: d => (d.currency === "BTC" ? d.amount : d.amount.format('c')) 
        },
        {
            name: TranslateExt('Currency'),
            selector: 'currency',
            sortable: true,
        },
        {
            name: TranslateExt('Status'),
            selector: 'status',
            sortable: true,
            cell: d => <span className={"badge pb-1 font-12 payment-status " + d.statusClass}>{TranslateExt(d.status)}</span>
        },
        {
            name: TranslateExt('Date'),
            selector: 'date',
            sortable: true,
        },
    ],
    withdrawal: memoize(onCancel => [
        {
            name: TranslateExt('#'),
            selector: 'id',
            sortable: true,
            maxWidth:'50px',
            cell: d => <span className="badge badge-light">{d.id}</span>
        },
        {
            name: TranslateExt('Login'),
            selector: 'login',
            sortable: true,
            cell: d => <b>#{d.login}</b>
        },
        {
            name: TranslateExt('PSP'),
            selector: 'psp',
            sortable: true,
            cell: d => <span><img src={"/assets/psp-logo/" + (d.pspLogo || "defaultlogo.svg")} alt="" width="30" className="mb-1" />&nbsp; {d.psp}</span>
        },
        {
            name: TranslateExt('Amount'),
            selector: 'amount',
            sortable: true,
            cell: d => (d.currency === "BTC" ? d.amount : d.amount.format('c')) 
        },
        {
            name: TranslateExt('Currency'),
            selector: 'currency',
            sortable: true,
        },
        {
            name: TranslateExt('Status'),
            selector: 'status',
            sortable: true,
            cell: d => <span className={"badge pb-1 font-12 payment-status " + d.statusClass}>{d.status}</span>
        },
        {
            name: TranslateExt('Date'),
            selector: 'date',
            sortable: true,
        },
        {
            cell: (d) => ((d.status === "Pending") ? <a href="#cancel" title={TranslateExt("Cancel Withdrawal")} onClick={(e) => onCancel(e, d.transactionId)}><i className="far fa-times-circle text-danger font-17"></i></a> : ""),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }
    ]),
    internalTransfer: [
        {
            name: TranslateExt('From Account'),
            selector: 'fromAccount',
            sortable: true,
            cell: d => <b>#{d.fromAccount}</b>
        },
        {
            name: TranslateExt('To Account'),
            selector: 'toAccount',
            sortable: true,
            cell: d => <b>#{d.toAccount}</b>
        },
        {
            name: TranslateExt('Currency'),
            selector: 'currency',
            sortable: true,
        },
        {
            name: TranslateExt('Amount'),
            selector: 'amount',
            sortable: true,
            cell: d => (d.currency === "BTC" ? d.amount : d.amount.format('c')) 
        },
        {
            name: TranslateExt('Status'),
            selector: 'status',
            sortable: true,
            cell: d => <span className={"badge pb-1 font-12 payment-status " + d.statusClass}>{TranslateExt(d.status)}</span>
        },
        {
            name: TranslateExt('Date'),
            selector: 'date',
            sortable: true,
        },
    ],
    kointraDeposit: memoize(onCancel => [
        {
            name: TranslateExt('Amount'),
            selector: 'amount',
            sortable: true,     
            cell: d=> <span>{d.amount.format('c')} {d.currency}</span>
        },      
        {
            name: TranslateExt('Reference'),
            selector: 'reference',
            sortable: true,
        },
        {
            name: TranslateExt('Create Date'),
            selector: 'created_on',
            sortable: true,
        },
        {
            cell: (d) => <a href="#cancel" title={TranslateExt("Cancel Withdrawal")} onClick={(e) => onCancel(e)}><i className="far fa-times-circle text-danger font-17"></i></a>,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }
    ]),
};